import { renderInDocument } from '@spotahome/soyuz/client';

import Main from './main';

renderInDocument(Main);
